import React from 'react'
import Container from 'js/pages/LandingPages/components/Container'
import { FeatureImage, FeatureImageType } from 'js/components/FeatureImage'
import { pushToDataLayer } from 'js/pages/LandingPages/utils'
import { SharedSectionProps } from './types'
import LSButton from 'js/components/LSButton'
import { APP_STORE_LINK } from '../content'

type Props = {
  title: string | null
  description: string | null
  features: { text: string | null }[]
  listDescription?: string
  image: {
    responsiveImage: FeatureImageType
  } | null
  downloadLinkText: string
  onOpenModal: (flag: boolean) => void
} & SharedSectionProps

const InfoSection = ({
  title,
  description,
  features,
  image,
  listDescription,
  downloadLinkText,
  onOpenModal,
}: Props) => {
  const handleOpenModal = () => {
    pushToDataLayer({
      event: 'click_event',
      click_type: 'button',
      click_text: downloadLinkText?.toLowerCase(),
      action: undefined,
      location: title?.toLowerCase(),
    })

    onOpenModal(true)
  }

  return (
    <section className="pt-[52px] md:pt-96">
      <Container>
        <div className="grid gap-x-[40px] lg:grid-cols-2 lg:grid-rows-1">
          <div className="relative order-1">
            <h2 className="quincy pb-32 pt-24 text-32 leading-37 lg:pb-40 lg:pt-0 lg:text-48 lg:leading-52">
              {title}
            </h2>
            <p className="quincy pb-32 text-20 leading-23 lg:pb-24">
              {description}
            </p>
            <p className="text-14 font-demibold uppercase leading-19 tracking-1.12 lg:hidden">
              {listDescription}
            </p>
            <div className="flex flex-col items-start">
              <LSButton
                link
                size="large"
                href={APP_STORE_LINK}
                variant="primary"
                upperCase
                onClick={() =>
                  pushToDataLayer({
                    event: 'click_event',
                    click_type: 'button',
                    click_text: 'download',
                    action: undefined,
                    location: title?.toLowerCase(),
                  })
                }
                className="ml-0 block lg:hidden"
              >
                {downloadLinkText}
              </LSButton>
              <LSButton
                link={false}
                variant="primary"
                size="large"
                upperCase
                className="relative ml-0 hidden py-[19px] lg:block lg:py-[14.5px]"
                onClick={handleOpenModal}
              >
                {downloadLinkText}
              </LSButton>
              <ul className="relative -order-1 -m--18 mb-8 mt-28 lg:order-1 lg:mb-0 lg:mt-[45px]">
                {features.map(({ text }) => (
                  <li
                    key={text}
                    className="list-outside list-disc pb-[22px] pl-[10px] text-17 font-semiregular leading-21 lg:pb-24"
                  >
                    {text}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="relative -order-1 text-center lg:order-1 lg:text-right">
            <FeatureImage
              image={image?.responsiveImage as FeatureImageType}
              className="rounded-8"
            />
          </div>
        </div>
      </Container>
    </section>
  )
}

export default InfoSection
